const scrollButtons = document.querySelectorAll(".js-scroll-button");

function scrollDownFullHeight() {
    scrollButtons.forEach((button) => {
        button.addEventListener("click", (e) => {
            e.preventDefault();
            gsap.to(window, {
                duration: 0.6,
                ease: "power4.easeInOut",
                scrollTo: { y: window.innerHeight }
            });
        });
    });
  
}

function scrollToTarget(el, target) {
    el.addEventListener("click", (e) => {
        e.preventDefault();
        gsap.to(window, {
            duration: 0.6,
            ease: "power4.easeInOut",
            scrollTo: { y: target, offsetY: header.offsetHeight * 3 }
        });
    });
}
